//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: ['selection', 'selectionLive', 'numSelections', 'freebet', 'mini'],
  data() {
    return {
      loading: true,
      balance: null
    }
  },
  filters: {
    format_odds(value, oddsFormat) {
      return _.get(value, 'display_odds.' + oddsFormat, parseFloat(value.odds).toFixed(2))
      //return parseFloat(value.odds).toFixed(2)
    }
  },
  watch: {},
  computed: {
    is_each_way: {
      get() {
        return _.get(this.selection, 'outcome.is_each_way')
      },
      set(value) {
        this.$store.commit('betslip/setEachway', { key: _.get(this.selection, 'outcome.id'), value: value })
      }
    },
    stake: {
      get() {
        return _.get(this.$store.state.betslip, 'stakes.' + _.get(this.selection, 'outcome.id'))
      },
      set(value) {
        this.$store.commit('betslip/setStakes', { key: _.get(this.selection, 'outcome.id'), value: value })
      }
    },
    oddsChanged() {
      if (!this.selectionLive) return false
      return _.get(this.selection, 'outcome.odds') != _.get(this.selectionLive, 'odds')
    },
    betType() {
      return this.$store.state.betslip.betType
    },
    selections() {
      return this.$store.state.betslip.selections
    },
    selected() {
      let mySelections = _.map(this.$store.state.selections, 'outcome.id')
      return _.includes(mySelections, this.outcome.id)
    }
  },
  mounted() {},
  methods: {
    changeEW() {},
    changeStake() {
      console.log('changeStake')
      this.$store.commit('betslip/setStakeSingle', null)
    },
    remove(selection) {
      this.$store.commit('betslip/remove', {
        event: selection.event,
        market: selection.market,
        outcome: selection.outcome
      })
      this.$store.commit('betslip/setError', null)
      if(this.selections == 0) {
        this.$store.commit('betslip/toggleBetslip', false)
      }
    },
    addToSlip(event, market, outcome) {
      //console.log(event, market, outcome)
      if (this.selected) {
        this.$store.commit('remove', { event: event, market: market, outcome: outcome })
      } else {
        this.$store.commit('add', { event: event, market: market, outcome: outcome })
      }
    },
    formatOutcomeName() {
      if (_.get(this.selection, 'outcome.fullname')) {
        return this.$t(_.get(this.selection, 'outcome.fullname'));
      }
      return this.$t(_.get(this.selection, 'outcome.name'));
    }
  }
}
